export enum RecorChangeType {
	INSERT = 1,
	UPDATE = 2,
	DELETE = 3,
	SYNC = 4,
}
